export default defineNuxtRouteMiddleware((to) => {
  if (to.path === '/') {
    return navigateTo({ path: '/fr', query: to.query, hash: to.hash }, { redirectCode: 301 })
  }

  if (to.path.endsWith('/')) {
    const nextPath = to.path.replace(/\/+$/, '') || '/'
    return navigateTo({ path: nextPath, query: to.query, hash: to.hash }, { redirectCode: 301 })
  }
})
